import { t } from '@lingui/macro'

// ================================ Types ================================

export type DosageRow = {
  timeOfDay: string
  quantity: number
  unit: string
  fhirWhen: string
}

// ================================ Constants ================================

export const FHIR_WHEN_TO_INDEX: Record<string, number> = {
  MORN: 0,
  NOON: 1,
  EVE: 2,
  NIGHT: 3,
  HS: 3,
}

export const getUnitOptions = () => [
  {
    value: 'pills',
    label: t({ id: 'medication.unit.pill', message: 'pil(len)' }),
  },
  { value: 'ml', label: 'ml' },
  {
    value: 'teaspoon',
    label: t({ id: 'medication.unit.teaspoon', message: 'theelepel (5ml)' }),
  },
  {
    value: 'tablespoon',
    label: t({ id: 'medication.unit.tablespoon', message: 'eetlepel (15ml)' }),
  },
  {
    value: 'drops',
    label: t({ id: 'medication.unit.drop', message: 'druppel(s)' }),
  },
  {
    value: 'puffs',
    label: t({ id: 'medication.unit.puff', message: 'puff(s)' }),
  },
  {
    value: 'sprays',
    label: t({ id: 'medication.unit.spray', message: 'verstuiving(en)' }),
  },
  {
    value: 'applications',
    label: t({
      id: 'medication.unit.application',
      message: 'applicatie(s)',
    }),
  },
  {
    value: 'patches',
    label: t({ id: 'medication.unit.patch', message: 'pleister(s)' }),
  },
  {
    value: 'sachets',
    label: t({ id: 'medication.unit.sachet', message: 'zakje(s)' }),
  },
  {
    value: 'suppositories',
    label: t({
      id: 'medication.unit.suppository',
      message: 'zetpil(len)',
    }),
  },
  {
    value: 'injections',
    label: t({ id: 'medication.unit.injection', message: 'injectie(s)' }),
  },
  {
    value: 'units',
    label: t({ id: 'medication.unit.units', message: 'eenheden' }),
  },
]

export const getDefaultDosageRows = (): DosageRow[] => [
  {
    timeOfDay: t({
      id: 'medication.frequency.morning',
      message: "'s ochtends",
    }),
    quantity: 0,
    unit: 'pills',
    fhirWhen: 'MORN',
  },
  {
    timeOfDay: t({ id: 'medication.frequency.midday', message: "'s middags" }),
    quantity: 0,
    unit: 'pills',
    fhirWhen: 'NOON',
  },
  {
    timeOfDay: t({ id: 'medication.frequency.evening', message: "'s avonds" }),
    quantity: 0,
    unit: 'pills',
    fhirWhen: 'EVE',
  },
  {
    timeOfDay: t({
      id: 'medication.frequency.beforeSleep',
      message: 'voor het slapengaan',
    }),
    quantity: 0,
    unit: 'pills',
    fhirWhen: 'NIGHT',
  },
]
